module.exports = __webpack_public_path__ + "img/1c04d9e9473c24be089bb335f612cb29.png";